/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2020, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

//
// This is the client configuration tree.
// Guide: https://manual.os-js.org/v3/config/#client
// Complete config tree: https://github.com/os-js/osjs-client/blob/master/src/config.js
//
import defaultWallpaper from './wallpaper.png';

export default {
  // auth: {
  //   login: {
  //     username: 'demo',
  //     password: 'demo'
  //   }
  // }

  desktop: {
    settings: {
      theme: 'NeoOSDarkTheme',
      animations: true,
      panels: [
        {
          position: 'bottom',
          items: [
            { name: 'menu' },
            { name: 'windows' },
            { name: 'tray' },
            { name: 'clock' },
          ],
        },
      ],
      background: {
        src: defaultWallpaper,
        color: '#000000',
        style: 'cover',
      },
    },
  },
  vfs: {
    mountpoints: [
      {
        name: 'apps',
        label: 'Applications',
        adapter: 'apps',
        icon: { name: 'user-home' },
        attributes: {
          visibility: 'restricted',
          readOnly: true,
        },
      },
      {
        name: 'home',
        label: 'Home',
        adapter: 'system',
        icon: { name: 'user-home' },
      },
      {
        name: 'shared',
        label: 'Shared',
        adapter: 'system',
        icon: { name: 'folder-publicshare' },
      },
    ],
  },

  // auth0: {
  //   domain: 'ducminhquan.auth0.com',
  //   client_id: 'qT44wE8Kvq804ny55MoBNUtOlnieM0BA',
  //   redirect_uri: 'http://localhost:8000/',
  //   // audience: 'https://ducminhquan.auth0.com/api/v2/',
  // },

  auth0: {
    domain: 'ttgt-dongnai.us.auth0.com',
    client_id: '44Ix4SjBuypRjzmKwThgVYBiEqsqCgpC',
    redirect_uri: 'https://operation.dongnai.ttgt.vn/',
    // audience: 'https://ducminhquan.auth0.com/api/v2/',
  },

  // @neoos/common-devices-application
  'common-devices-application': {
    api: 'https://operation.dongnai.ttgt.vn/api/common-devices',
    baseUrl: 'https://operation.dongnai.ttgt.vn',
    production: true,
  },

  // @neoos/bus-led-application
  'bus-led-application': {
    api: 'https://operation.dongnai.ttgt.vn/api/common-devices',
    production: true,
    map: {
      center: [10.964112, 106.856461],
      zoom: 14,
      tileLayer: 'https://map.stis.vn/dongnai/{z}/{x}/{y}.png',
      attribution: '© FPT Information Systems',
    },
    apiText: 'https://api.dongnai.ttgt.vn/v4/led/preview?text',
  },

  'common-group-application': {
    api: 'https://operation.dongnai.ttgt.vn/api/common-devices',
    production: true,
  },

  'common-device-types-application': {
    api: 'https://operation.dongnai.ttgt.vn/api/common-devices',
  },

  'common-location-application': {
    api: 'https://operation.dongnai.ttgt.vn/api/common-devices',
    baseUrl: 'https://operation.dongnai.ttgt.vn',
    production: true,
    map: {
      center: [10.964112, 106.856461],
      zoom: 14,
      tileLayer: 'https://map.stis.vn/dongnai/{z}/{x}/{y}.png',
      attribution: '© FPT Information Systems',
    },
  },
};
